export const airports = [
  { label: "Murtala Muhammed International Airport", value: "Lagos" },
  { label: "Nnamdi Azikiwe International Airport", value: "Abuja" },
  { label: "Mallam Aminu Kano International Airport", value: "Kano" },
  { label: "Port Harcourt International Airport", value: "Port Harcourt" },
  { label: "Owerri International Airport", value: "Owerri" },
  { label: "Akwa Ibom International Airport", value: "Uyo" },
  { label: "Maiduguri International Airport", value: "Maiduguri" },
  { label: "Yola International Airport", value: "Yola" },
  { label: "Sani Abacha International Airport", value: "Kano" },
  { label: "Aminu Saleh International Airport", value: "Kano" },
  { label: "Akanu Ibiam International Airport", value: "Enugu" },
];

export const nigerianStatesAndAirports = [
  { state: "Lagos", code: "LOS" },
  { state: "Abuja", code: "ABV" },
  { state: "Kano", code: "KAN" },
  { state: "Port Harcourt", code: "PHC" },
  { state: "Owerri", code: "QOW" },
  { state: "Uyo", code: "UYO" },
  { state: "Maiduguri", code: "MIU" },
  { state: "Yola", code: "YOL" },
  { state: "Kano", code: "KAN" },
  { state: "Enugu", code: "ENU" },
];

export const findLocationFromIATA = (val: string) => {
  const airport = nigerianStatesAndAirports.find((state) => state.code === val);
  return airport?.state;
};
